const context = require.context('./', true, /.*/);

const middleware = [];

context.keys().forEach((key) => {
  if (!(/\.js/).test(key) && !(/index/).test(key)) {
    const dflt = context(key).default;

    if (dflt) {
      middleware.push(context(key).default);
    }
  }
});

export default middleware;



// WEBPACK FOOTER //
// ./app/middleware/index.js